import { camelCase } from 'lodash-es';
import { useTranslation } from 'next-i18next/pages';

import { CareType } from '@pflegia/types/api/employer/care-type';

import { CareTypeIcon } from '@shared/components/care-type-icon/CareTypeIcon';

export interface ClientAssignmentItemType {
  label: CareType;
}

const ClientAssignmentItem: React.FC<ClientAssignmentItemType> = ({ label }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('jobDetails', { keyPrefix: 'clientAssignment' });

  return (
    <>
      <CareTypeIcon className='size-16' type={label} />
      <h3 className='ml-2 text-xl font-medium break-words hyphens-auto whitespace-nowrap md:text-2xl' lang={language}>
        {t(camelCase(label))}
      </h3>
    </>
  );
};

export default ClientAssignmentItem;
